import { formatAddress } from 'common/utils'
import { reportsConstants } from 'locale/team'
import EditProfileCard from '../../../../../../components/forms/screens/TeamMemberEditFormV2/EditProfileCard'
import { fmtDate } from './dateUtils'
import ProfileFieldRow from './ProfileFieldRow'

type Props = { profile: Record<string, any>; t: (k: string) => string }

const PersonalDetailsViewCard = ({ profile, t }: Props) => (
  <EditProfileCard
    title={t(reportsConstants.PROFILE_VIEW_CARD_PERSONAL)}
    testId="profile-view-personal"
    showTitleDivider
    fullWidth
  >
    <ProfileFieldRow
      label={t(reportsConstants.PROFILE_VIEW_DOB)}
      value={fmtDate(profile.dateOfBirth)}
    />
    <ProfileFieldRow
      label={t(reportsConstants.PROFILE_VIEW_PHONE)}
      value={profile.phoneNumber}
    />
    <ProfileFieldRow
      label={t(reportsConstants.PROFILE_VIEW_ADDRESS)}
      value={profile.address ? formatAddress(profile.address) : ''}
    />
    <ProfileFieldRow
      label={t(reportsConstants.PROFILE_VIEW_ALLERGIES)}
      value={profile.hasAllergies}
    />
    {profile.hasAllergies === 'Yes' && (
      <ProfileFieldRow
        label={t(reportsConstants.PROFILE_VIEW_ALLERGY_DETAILS)}
        value={profile.allergies}
      />
    )}
  </EditProfileCard>
)

export default PersonalDetailsViewCard
